import $ from 'jquery';
import mapboxgl from '!mapbox-gl';

import { easeTo, fitBounds, flyTo, getPropertyFeatures, hideAppellation, hideProperties, map, mapInitialized, mapMarkers, showAppellation, showProperty } from './main';
import { $Elements, Classes, Durations, Events } from '../global/constants';
import { wait } from '../global/helpers';

$Elements.document.on(Events.page.loaded, () => {

	if(map) {

		if(mapInitialized) {
			initMarkers();
		}
		else {
			$Elements.document.on('map.initialized', initMarkers);
		}
	}
});

async function initMarkers() {

	if(typeof map_params !== 'undefined') {

		if(map_params.properties) {

			for(const property of map_params.properties) {

				const marker = $(property.marker);

				mapMarkers.push(new mapboxgl.Marker({
					element: marker[0],
					anchor: 'center',
				}).setLngLat(property.coordinates).addTo(map));

				const infowindow = $(property.infowindow);

				mapMarkers.push(new mapboxgl.Marker({
					element: infowindow[0],
					anchor: 'bottom',
				}).setLngLat(property.coordinates).addTo(map));
			}

			$Elements.body.on('click', '.toggle-property', async function() {
				showAppellation();
				hideProperties();

				$('#properties-collapse').collapse('hide');
				$('.toggle-property, .property-infowindow').removeClass(Classes.active);
				$(this).addClass(Classes.active);
				$('.property-infowindow[data-property=' + this.dataset.property + ']').addClass(Classes.active);

				const coordinates = JSON.parse(this.dataset.coordinates);
				await easeTo({
					center: coordinates,
					pitch: 60,
					padding: { top: 200 },
					zoom: 13
				});
			});

			$Elements.body.on('click', '.toggle-parcelles', async function() {
				hideAppellation();

				const names = JSON.parse(this.dataset.parcelles);
				const bounds = new mapboxgl.LngLatBounds();

				if(Array.isArray(names) && names.length) {

					names.forEach(name => {
						const parcelle = getPropertyFeatures(name);
						showProperty(name);

						if(Array.isArray(parcelle) && parcelle.length) {
							parcelle.forEach(layer => layer.geometry.coordinates[0].forEach(coordinates => bounds.extend(coordinates)));
						}
					});

					await fitBounds(bounds, {
						pitch: 60,
						padding: 20,
					});
				}
			});

			await wait(Durations.animations);

			await flyTo({
				center: [-0.045, 44.9],
				pitch: 60,
				zoom: 11
			});

			showAppellation();
		}
	}
}
